import { type ReactNode } from "react";

// Assuming an item has 16px of padding 8px on each side.
export const BT_LIST_HEADER_OVERFLOW_PADDING = 16;

export type TBTListHeaderIconVariant =
    | "feedback"
    | "help"
    | "settings"
    | "activity"
    | "history"
    | "print"
    | "export"
    | "filter";

export const ICON_VARIANT_ORDER: TBTListHeaderIconVariant[] = [
    "feedback",
    "help",
    "settings",
    "activity",
    "history",
    "print",
    "export",
    "filter",
];

export interface IBTListHeaderIcon {
    icon: TBTListHeaderIconVariant;
    onClick?: (() => void) | (() => Promise<void>);
    to?: string;
    selected?: boolean;
    loading?: boolean;
    isHidden?: boolean;
    inMenu?: boolean;
    inMenuMdBreakpoint?: boolean;
    pinned?: boolean;
    popoverContent?: ReactNode;
    popoverWidthType?: "narrow" | "wide" | "unrestricted";
}

export interface IBTListHeaderIconDefaults {
    icon: ReactNode;
    testid: string;
    text: string;
    ariaLabel: string;
    tooltip?: string;
}
export interface IBTListHeaderActionButtonsProps {
    testid: string;
    iconActions?: IBTListHeaderIcon[];
    primaryAction?: ReactNode;
    secondaryActions?: ReactNode[];
    filterCount?: number;
    jobName?: ReactNode;
    entityType?: string;
}
